import React, { useEffect, useRef, useState, useContext } from 'react'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import useAxios from 'axios-hooks'
import PassimPlayer from '../rosemary/passimPlayer'
import CustomImage from '../../customImage/customImage'
import ProfileMediaArrow from '../imgComponents/profileMediaArrow'
import ReactHtmlParser from 'react-html-parser'
import { AppContext } from '../../../context/app'
import ShareModal from '../../shareModal/shareModal'
import { create_share_url } from '../../../utils/helper'

const VerticalDeckSection = ({
  componentData,
  setModalState,
  isEdit = true,
  theme,
  playerData,
  setPlayerData,
  playerContainerRef,
  pageURL = '',
}) => {
  const { addRemoveFollow, checkIsFollower, athletePartnerData, getFollowerCount } =
    useContext(AppContext)
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [activeTab, setActiveTab] = useState(1)
  const {
    customNavigate,
    CONTENT_FILTER_XAVIER,
    getTemplateImage,
    VideoPlaceholder,
    SquareDummyImg,
    ThumbsUpIcon,
    SquareDraftIcon,
    SquareShareIcon,
    EditIcon,
  } = useTemplateHook()
  const [contentDataTab1, setContentDataTab1] = useState([])
  const listContainerRef = useRef(null)
  const listItemRefs = useRef({})
  const athletePartnerObj = athletePartnerData.find((p) => p.page_url === `/${pageURL}`)
  const [shareModal, setShareModal] = useState(false)

  const language = localStorage.getItem('language') || 'en'

  const [{ data: contentListTab1 }, contentListCallTab1] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const getDynamicFilters = (autoPayload) => {
    let obj = {}

    let ownersObj = autoPayload.find((info) => info.type === 'owners')

    if (ownersObj) {
      obj['owners'] = ownersObj?.values
    }

    return obj
  }

  const getFilterPayload = (tabData) => {
    return tabData?.type === 'STATIC'
      ? { content_ids: tabData?.content_data }
      : {
          system_defined: tabData?.auto_payload.filter((info) => info.type === 'system_defined'),
          custom_defined: tabData?.auto_payload.filter((info) => info.type === 'custom_defined'),
          video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
          ...getDynamicFilters(tabData?.auto_payload),
        }
  }

  useEffect(() => {
    if (!isEmpty(data?.tab_section1?.content_data) || !isEmpty(data?.tab_section1?.auto_payload)) {
      let filterPayload = getFilterPayload(data?.tab_section1)

      contentListCallTab1({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data?.tab_section1?.type === 'STATIC'
              ? ''
              : data?.tab_section1?.order_by === 'title'
              ? `title.${language}`
              : data?.tab_section1?.order_by,
          reverse: data?.tab_section1?.type === 'STATIC' ? '' : data?.tab_section1?.reverse,
          page_size: 25,
        },
      })
    } else {
      setContentDataTab1([])
    }
  }, [data])

  useEffect(() => {
    if (!isEmpty(data?.player?.data)) {
      setPlayerData(data?.player)
    } else {
      setPlayerData({})
    }
  }, [data, pageURL])

  useEffect(() => {
    if (contentListTab1 && contentListTab1.success) {
      if (data.tab_section1.type === 'STATIC') {
        contentListTab1?.data.sort((a, b) => {
          let sortingArr = data.tab_section1.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentDataTab1(contentListTab1.data)
    }
  }, [contentListTab1])

  useEffect(() => {
    const activeId = playerData?.data?.id
    const container = listContainerRef.current
    const itemEl = listItemRefs.current[activeId]
    if (activeTab !== 1 || !activeId || !container || !itemEl) return

    const containerRect = container.getBoundingClientRect()
    const itemRect = itemEl.getBoundingClientRect()
    const isOutOfView = itemRect.top < containerRect.top || itemRect.bottom > containerRect.bottom
    if (isOutOfView) {
      container.scrollTo({
        top: container.scrollTop + itemRect.top - containerRect.top,
        behavior: 'smooth',
      })
    }
  }, [playerData, contentDataTab1, activeTab])

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
      isVerticalStreamDeck: true,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const handleContentClick = (id) => {
    customNavigate('DIRECT', `/athlete/${pageURL}?content_id=${id}`)
  }

  return (
    <div
      className={`${
        isEdit && hoverState && 'component-hover-class'
      } relative py-[16px] lg:py-8 w-full`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <div
          className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-4 right-4 z-10 flex justify-center items-center cursor-pointer"
          onClick={() => handleModal()}
        >
          <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
        </div>
      )}
      <div
        style={{
          paddingLeft: '3.66032%',
          paddingRight: '3.66032%',
        }}
        className="w-full flex justify-center items-center"
      >
        <div className="w-full flex flex-col xl:flex-row xl:justify-between">
          <div className="w-full xl:w-[64.5%]">
            <p
              style={{ color: getStyleValue('header_section', 'heading_color', '#fff') }}
              className="xl:text-2xl md:text-xl text-xs font-semibold mb-0"
            >
              {data?.heading}{' '}
              {getFollowerCount(athletePartnerObj?._id) > 0 ? (
                <span className="text-[10px] text-muted font-normal mb-0">
                  ({getFollowerCount(athletePartnerObj?._id)}){' '}
                  {getFollowerCount(athletePartnerObj?._id) === 1 ? 'Follower' : 'Followers'}{' '}
                </span>
              ) : null}
            </p>
            <div className="flex mt-3 lg:mt-4">
              {[...data?.category_options].map((item, index) => (
                <p
                  style={{
                    marginBlockEnd: '0',
                    background: getStyleValue('header_section', 'category_bg_color', '#d6ff05'),
                    color: getStyleValue('header_section', 'category_color', '#010101'),
                    padding: '2px 8px',
                    marginLeft: index ? '15px' : '',
                  }}
                  className="text-[10px] font-semibold md:text-xs line-clamp-1 cursor-pointer mb-0"
                  onClick={() => handleRedirect(item.link)}
                  key={index}
                >
                  {item.text}
                </p>
              ))}
            </div>

            <div
              ref={playerContainerRef}
              tabIndex={-1}
              style={{ aspectRatio: '1.7777' }}
              className="w-full mt-3 relative focus:outline-none"
            >
              {isEdit || isEmpty(playerData) ? (
                <div className="w-full h-full relative flex justify-center items-center">
                  <CustomImage
                    imageUrl={getTemplateImage(data?.image_s3key)}
                    imgClass="w-full h-full"
                    loaderClass="w-full h-full"
                    loaderStyle={{ background: '#5A5A5A50' }}
                    imgAlt={'recent story Img'}
                    errorPlaceholder={VideoPlaceholder}
                  />
                </div>
              ) : (
                <div className="w-full h-full overflow-hidden">
                  <PassimPlayer
                    data={playerData}
                    poster={getTemplateImage(data?.image_s3key)}
                    controlBar={true}
                    onClickRedirect={() => {}}
                    loader={false}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="w-full xl:w-[34%] mt-4 xl:mt-0 flex flex-col justify-end">
            <div className="xl:h-[80px]">
              {/* {data?.button?.enabled ? ( */}
              <button
                className="font-semibold py-1 px-3 md:px-6 border-none w-fit  md:text-base text-xs"
                style={{
                  color: getStyleValue('button', 'color', '#fff'),
                  backgroundColor: getStyleValue('button', 'button_background', '#4466fd'),
                  border: `2px solid ${getStyleValue('button', 'button_background', '#4466fd')}`,
                }}
                onClick={() =>
                  addRemoveFollow(
                    'CONTENT_PARTNER',
                    athletePartnerObj?._id,
                    !checkIsFollower('CONTENT_PARTNER', athletePartnerObj?._id),
                  )
                }
              >
                {checkIsFollower('CONTENT_PARTNER', athletePartnerObj?._id)
                  ? 'Following'
                  : 'Follow'}
              </button>
              <button
                className=" ml-5 font-semibold py-1 px-3 md:px-6 border-none w-fit  md:text-base text-xs"
                style={{
                  color: getStyleValue('button', 'color', '#fff'),
                  border: `2px solid ${getStyleValue('button', 'button_background', '#4466fd')}`,
                }}
                onClick={() => setShareModal(true)}
              >
                Share
              </button>
              {/* ) : null} */}
            </div>
            <div className="w-full xl:h-[calc(100%-80px)]">
              <div className="w-full flex items-center font-semibold">
                <div
                  className="flex justify-center items-center w-1/2 relative cursor-pointer"
                  onClick={() => setActiveTab(1)}
                >
                  <ProfileMediaArrow
                    color={
                      activeTab === 1
                        ? getStyleValue('content_section', 'tab_bg_active', '#fc0001')
                        : getStyleValue('content_section', 'tab_bg_inactive', '#fefefe')
                    }
                    imgStyle={{ width: '100%' }}
                  />
                  <p
                    style={{
                      color:
                        activeTab === 1
                          ? getStyleValue('content_section', 'tab_text_active', '#ffffff')
                          : getStyleValue('content_section', 'tab_text_inactive', '#000000'),
                    }}
                    className="absolute text-sm xl:text-base mb-0"
                  >
                    {data.tab_section1.name}
                  </p>
                </div>
                <div
                  className="flex justify-center items-center w-1/2 relative cursor-pointer"
                  onClick={() => setActiveTab(2)}
                >
                  <ProfileMediaArrow
                    color={
                      activeTab === 2
                        ? getStyleValue('content_section', 'tab_bg_active', '#fc0001')
                        : getStyleValue('content_section', 'tab_bg_inactive', '#fefefe')
                    }
                    imgStyle={{ width: '100%' }}
                  />
                  <p
                    style={{
                      color:
                        activeTab === 2
                          ? getStyleValue('content_section', 'tab_text_active', '#ffffff')
                          : getStyleValue('content_section', 'tab_text_inactive', '#000000'),
                    }}
                    className="absolute text-sm xl:text-base mb-0"
                  >
                    {data.tab_section2.name}
                  </p>
                </div>
              </div>
              <div
                ref={listContainerRef}
                style={{ marginTop: '2%' }}
                className={`w-full ${
                  data?.user_interaction_section?.enabled
                    ? 'h-[69.23vw] md:h-[40vw] xl:h-[25vw] 2xl:h-[26.5vw]'
                    : 'h-[69.23vw] md:h-[40vw] xl:h-[29.5vw] 2xl:h-[30vw]'
                }  hidden-scrollbar-class overflow-hidden`}
              >
                {activeTab === 1 ? (
                  contentDataTab1.map((item, index) => {
                    return (
                      <div
                        ref={(el) => (listItemRefs.current[item?.content_id] = el)}
                        className={`flex justify-between w-full ${index && 'mt-3'}`}
                        key={index}
                      >
                        <CustomImage
                          imageUrl={getTemplateImage(item?.square)}
                          imgClass="aspect-square w-[15.9%] cursor-pointer"
                          loaderClass="aspect-square w-[15.9%]"
                          loaderStyle={{ background: '#5A5A5A50' }}
                          imgAlt={'square Img'}
                          errorPlaceholder={SquareDummyImg}
                          onClickRedirect={() => handleContentClick(item?.content_id)}
                          // onClickRedirect={() => customNavigate('DIRECT', getLink(item), isEdit)}
                        />
                        <div style={{ width: '80%' }}>
                          <p
                            style={{
                              background: getStyleValue(
                                'content_section',
                                'content_title_bg',
                                '#d6ff05',
                              ),
                              color: getStyleValue('content_section', 'content_title', '#d6ff05'),
                              padding: '2px 11px 2px 11px',
                            }}
                            className="cursor-pointer text-xs font-semibold line-clamp-1 w-fit mb-0"
                            onClick={() => handleContentClick(item?.content_id)}
                          >
                            {item.title}
                          </p>
                          <p
                            style={{
                              color: getStyleValue(
                                'content_section',
                                'content_description',
                                '#d6d6d6',
                              ),
                            }}
                            className="mb-0 text-[11px] mt-2 xl:mt-4 line-clamp-2"
                          >
                            {item?.description}
                          </p>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <>
                    <div style={{ lineHeight: '1.875rem' }} className={`custom-page `}>
                      <div style={{ color: '#fff' }} className="">
                        {!isEmpty(data) && ReactHtmlParser(data?.tab_section2?.content)}
                      </div>
                    </div>
                  </>
                )}
              </div>
              {data?.user_interaction_section?.enabled ? (
                <div className="flex w-full justify-between items-center mt-[16px]">
                  <div className="flex items-center">
                    <img
                      src={ThumbsUpIcon}
                      alt="abcd"
                      className="w-[38px] xl:w-[50px] aspect-square"
                    />
                    <img
                      src={SquareShareIcon}
                      alt="abcd"
                      className="w-[38px] xl:w-[50px] aspect-square ml-4"
                    />
                  </div>
                  <img
                    src={SquareDraftIcon}
                    alt="abcd"
                    className="w-[38px] xl:w-[50px] aspect-square"
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {shareModal && <ShareModal onClose={() => setShareModal(false)} link={create_share_url()} />}
    </div>
  )
}

export default withTheme(VerticalDeckSection)
